export const services = Object.freeze({
  NODE_ENDPOINT_GET_ENVCONF: "sys/getenvconf",
  NODE_ENDPOINT_SET_ENVCONF: "sys/setenvconf",
  NODE_ENDPOINT_GET_FAILEDDATACOLLECTION: "debug/store/imxFailedDataCollection",
  NODE_ENDPOINT_GET_DATACOLLECTION: "debug/store/imxDataCollection",
  NODE_ENDPOINT_GET_FETCHCOLLECTION: "debug/store/imxFetchCollection",
  NODE_ENDPOINT_GET_SYSINFO: "sys/info",
  NODE_ENDPOINT_GET_USERS: "sys/getAllUsers",
})
